export const aggridCategoryDisplayConstants = {
  TOGGLE_CATEGORY_DISPLAY: 'TOGGLE_CATEGORY_DISPLAY',
};
